import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import './StatCard.css'

const StatCard = ({ value, label, loading }) => {
    return (
        <div className="stat-card">
            <h3 className='font-1'>{loading ? <Skeleton width={50} /> : value}</h3>
            <p className='tkmr_gray_secondary font-2'>{label}</p>
            <div>
                <p className='tkmr_gray_primary'>total</p>
            </div>
        </div>
    );
};

StatCard.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string.isRequired,
    loading: PropTypes.bool,
};

StatCard.defaultProps = {
    value: null,
    loading: false,
};

export default StatCard;
